const defaultBranding = {
  name: "Keal",
  shortName: "Keal",
  productName: "Keal.club",
  legalName: "Keal.club",
  domain: "keal.club",
  appTitle: "Keal",
  logo: {
    src: "",
    alt: "Keal logo",
    mark: "CM",
    variants: {
      landing: {
        src: "",
        alt: "Keal logo",
      },
      auth: {
        src: "",
        alt: "Keal logo",
      }
    }
  },
  cameoLabel: "cameo",
  cameoLabelPlural: "cameos",
  talent: {
    name: "Lionel Messi",
    handle: "@lionelmessi",
    avatar: "/assets/images/messi.png",
  },
  messaging: {
    heroHeadline: "Be part of the club.",
    heroHeadlineColor: "var(--color-primary-400)",
    heroKicker: "Creator infrastructure",
    heroSubhead:
      "License and monetize your likeness across AI platforms with AI-powered guardrails.",
    heroDescription:
      "Keal.club is the trust layer between influencers and AI video apps. Set your boundaries once and let AI handle approvals, per-view payouts, and reporting while you focus on your career.",
    signInLabel: "Sign in to Keal",
    exploreFeaturesLabel: "Explore features",
    platformKicker: "Platform",
    platformHeadline: "One place to control how AI can use your likeness.",
    platformDescription:
      "See which apps are using your cameo, what they're allowed to do, and how much you're earning--without needing a team or any tech setup.",
    workflowKicker: "Workflow",
    workflowHeadline: "From onboarding to payouts in four guided steps.",
    ctaKicker: "Ready?",
    ctaHeadline:
      "Decide how AI can use your cameo--and get paid for every view.",
    ctaDescription:
      "Claim your Keal.club profile, connect the AI apps you already use, and let our AI handle approvals and per-view payouts in the background.",
    ctaCreateAccountLabel: "Create account",
    ctaTalkToUsLabel: "Talk to us",
    loginHeadline: "Welcome back",
    returnHomeLabel: "return to homepage",
  },
  colors: {
    primary: {
      50: "#e5fff9",
      100: "#ccfff3",
      200: "#99ffe7",
      300: "#66ffdb",
      400: "#33ffcf",
      500: "#00ffc4",
      600: "#00cc9c",
      700: "#009975",
      800: "#00664e",
      900: "#003327",
      950: "#00241b",
    },
    secondary: {
      50: "#ecfbff",
      100: "#d5f4ff",
      200: "#abe8ff",
      300: "#7cd9ff",
      400: "#42c4ff",
      500: "#1aa6f7",
      600: "#0f82d3",
      700: "#0d67aa",
      800: "#0e4d81",
      900: "#0c395f",
    },
    gray: {
      50: "#f8fafc",
      100: "#eef2f8",
      200: "#d9e0ec",
      300: "#b3bfd4",
      400: "#8a99b2",
      500: "#627089",
      600: "#475569",
      700: "#313b4b",
      800: "#1f2937",
      900: "#111827",
      950: "#050b17",
    },
    slate: {
      950: "#030712",
      900: "#0b1120",
      800: "#11192f",
      700: "#1b253b",
    },
  },
  text: {
    primary: "#ffffff",
    secondary: "#cbd5e1",
    muted: "#94a3b8",
    onPrimary: "#0b1120",
    heading: "#ffffff",
    onContrast: "#0b1120",
  },
  shadows: {
    card: "0 4px 10px #3ecf8e55, 0 0px 1px #ffffff",
    cardInset: "inset 0 1px 0 rgba(0,0,0,0.6)",
    glow: "0 0 18px rgba(0, 255, 196, 0.25)",
    button: "0 10px 24px rgba(0, 255, 196, 0.15)",
  },
  surfaces: {
    base: "#050b17",
    card: "#0b1220",
    muted: "rgba(15, 23, 42, 0.4)",
    borderSubtle: "rgba(148, 163, 184, 0.18)",
    contrast: "#ffffff",
  },
  fonts: {
    sans: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    heading:
      '"Sora", "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  },
  buttons: {
    primaryGradient: false,
  },
  widgets: {
    landing: {
      aiApprovals: {
        title: "AI approvals",
        summary: "100% automated",
        badge: "Real-time",
        requests: [
          {
            id: 1,
            app: "Runway ML",
            prompt:
              "@featuredtalent doing a celebratory dance on the moon after scoring a goal",
            status: "approved",
          },
          {
            id: 2,
            app: "Pika Labs",
            prompt:
              "@jakepaul as a news anchor reading a fake headline about my crypto giveaway",
            status: "blocked",
          },
          {
            id: 3,
            app: "Sora",
            prompt: "@samal walking through Times Square at night in the rain",
            status: "approved",
          },
        ],
      },
      creatorEarnings: {
        label: "Creator earnings",
        amount: 128400,
        periodLabel: "/ 30 days",
        trendLabel: "+24% MoM",
        statusLabel: "Auto payout enabled",
      },
    },
    guardrails: {
      promptTesterPlaceholder:
        "Example: __STAR_HANDLE__ speaking at a charity gala about education access",
      examplePrompts: {
        rejected: [
          {
            id: 1,
            prompt:
              "__STAR_HANDLE__ endorsing a specific political candidate and telling viewers to vote for them",
            reason:
              "Political campaigning and endorsements are blocked without explicit consent.",
          },
          {
            id: 2,
            prompt:
              "__STAR_HANDLE__ promoting a guaranteed crypto investment with no risk",
            reason:
              "Financial scams and misleading investment promises are blocked.",
          },
        ],
        approved: [
          {
            id: 1,
            prompt:
              "__STAR_HANDLE__ congratulating a youth mentorship cohort at a nonprofit event",
            reason:
              "Positive and non-controversial content without endorsements or unsafe claims.",
          },
          {
            id: 2,
            prompt:
              "__STAR_HANDLE__ giving a short motivational quote about teamwork and resilience",
            reason:
              "General inspirational message with no sensitive or prohibited topics.",
          },
        ],
      },
    },
    generations: {
      promptReplacements: [],
    },
    dashboard: {
      recentVideos: [],
    },
    protection: {
      feed: [
        {
          id: "authorized-1",
          status: "authorized",
          statusLabel: "Authorized",
          verified: true,
          platform: "YouTube",
          content: "Adidas brand campaign",
          risk: "Verified",
          timestamp: "Today, 11:02 AM",
          icon: "bi bi-shield-check",
          matchPercent: 100,
          reach: "2.4M views",
          detectedAt: "Today, 11:02 AM",
          videoSrc: "/assets/videos/protection/Authorized-Adidas.mp4",
          sourceUrl: "https://www.youtube.com/watch?v=adidas-messi-campaign",
        },
        {
          id: "detected-1",
          status: "detected",
          statusLabel: "Detected",
          verified: false,
          platform: "Unknown AI Site",
          content: "Beijing 2022 fake endorsement",
          risk: "High",
          timestamp: "Today, 10:38 AM",
          icon: "bi bi-exclamation-triangle",
          matchPercent: 96,
          reach: "180K views",
          detectedAt: "Today, 10:38 AM",
          videoSrc: "/assets/videos/protection/Unauthorized-Beijing 2022-fake endorsement video.mp4",
          sourceUrl: "https://www.unknownai.com/watch/beijing-2022-endorsement",
        },
        {
          id: "detected-2",
          status: "detected",
          statusLabel: "Detected",
          verified: false,
          platform: "TikTok",
          content: "Messi homeless deepfake clip",
          risk: "Medium",
          timestamp: "Yesterday, 6:14 PM",
          icon: "bi bi-camera-video",
          matchPercent: 92,
          reach: "410K views",
          detectedAt: "Yesterday, 6:14 PM",
          videoSrc: "/assets/videos/protection/Unauthorized-Messi homeless-Deepfake clip.mp4",
          sourceUrl: "https://www.tiktok.com/@fanclips/video/734928174018221",
        },
        {
          id: "detected-3",
          status: "detected",
          statusLabel: "Detected",
          verified: false,
          platform: "Instagram",
          content: "AI remix promo spot",
          risk: "Medium",
          timestamp: "Yesterday, 2:22 PM",
          icon: "bi bi-instagram",
          matchPercent: 88,
          reach: "95K views",
          detectedAt: "Yesterday, 2:22 PM",
          videoSrc: "/assets/videos/protection/Unauthorized-AI remix promo spot.mp4",
          sourceUrl: "https://www.instagram.com/reel/C9aiRemix7Q2/",
        },
        {
          id: "detected-4",
          status: "detected",
          statusLabel: "Detected",
          verified: false,
          platform: "YouTube",
          content: "Messi turning into a super hero",
          risk: "High",
          timestamp: "Yesterday, 8:05 AM",
          icon: "bi bi-youtube",
          matchPercent: 94,
          reach: "620K views",
          detectedAt: "Yesterday, 8:05 AM",
          videoSrc: "/assets/videos/protection/Unauthorized-Messi turning into a super hero-deepfake compilation.mp4",
          sourceUrl: "https://www.youtube.com/watch?v=super-hero-deepfake",
        },
        {
          id: "authorized-2",
          status: "authorized",
          statusLabel: "Authorized",
          verified: true,
          platform: "Apple MLS",
          content: "Apple MLS spot",
          risk: "Verified",
          timestamp: "Yesterday, 7:15 AM",
          icon: "bi bi-shield-check",
          matchPercent: 100,
          reach: "1.1M views",
          detectedAt: "Yesterday, 7:15 AM",
          videoSrc: "/assets/videos/protection/Authorized-Apple-MLS.mp4",
          sourceUrl: "https://tv.apple.com/show/major-league-soccer/umc.cmc.mls",
        },
        {
          id: "detected-5",
          status: "detected",
          statusLabel: "Detected",
          verified: false,
          platform: "Reddit",
          content: "Messi turning into a super hero",
          risk: "High",
          timestamp: "Mar 18, 2:42 PM",
          icon: "bi bi-chat-square-text",
          matchPercent: 90,
          reach: "240K views",
          detectedAt: "Mar 18, 2:42 PM",
          videoSrc: "/assets/videos/protection/Unauthorized-Messi turning into a super hero-deepfake compilation.mp4",
          sourceUrl: "https://www.reddit.com/r/deepfakeclips/comments/18q9x3a/compilation/",
        },
        {
          id: "authorized-3",
          status: "authorized",
          statusLabel: "Authorized",
          verified: true,
          platform: "Mastercard",
          content: "Mastercard campaign",
          risk: "Verified",
          timestamp: "Mar 18, 9:30 AM",
          icon: "bi bi-shield-check",
          matchPercent: 100,
          reach: "780K views",
          detectedAt: "Mar 18, 9:30 AM",
          videoSrc: "/assets/videos/protection/Authorized-Mastercard.mp4",
          sourceUrl: "https://www.mastercard.com/messi-campaign",
        },
        {
          id: "detected-6",
          status: "detected",
          statusLabel: "Detected",
          verified: false,
          platform: "Unknown AI Forum",
          content: "Messi knocking at door to ask for water",
          risk: "Medium",
          timestamp: "Mar 17, 11:12 PM",
          icon: "bi bi-exclamation-triangle",
          matchPercent: 86,
          reach: "42K views",
          detectedAt: "Mar 17, 11:12 PM",
          videoSrc: "/assets/videos/protection/Unauthorized-Messi knocking at door to ask for water.mp4",
          sourceUrl: "https://www.unknownaiforum.com/thread/40391",
        },
        {
          id: "authorized-4",
          status: "authorized",
          statusLabel: "Authorized",
          verified: true,
          platform: "Lowe's",
          content: "Lowe's collaboration",
          risk: "Verified",
          timestamp: "Mar 17, 3:45 PM",
          icon: "bi bi-shield-check",
          matchPercent: 100,
          reach: "560K views",
          detectedAt: "Mar 17, 3:45 PM",
          videoSrc: "/assets/videos/protection/Authorized-Lowe's.mp4",
          sourceUrl: "https://www.lowes.com/c/messi-partner",
        },
        {
          id: "detected-7",
          status: "detected",
          statusLabel: "Detected",
          verified: false,
          platform: "X (Twitter)",
          content: "Messi as Eagles fan statement",
          risk: "Low",
          timestamp: "Mar 16, 5:04 PM",
          icon: "bi bi-twitter-x",
          matchPercent: 82,
          reach: "38K views",
          detectedAt: "Mar 16, 5:04 PM",
          videoSrc: "/assets/videos/protection/Unauthorized-Messi as Eagles fan-AI-generated statement.mp4",
          sourceUrl: "https://x.com/creatornews/status/1769458129032",
        },
        {
          id: "detected-8",
          status: "detected",
          statusLabel: "Detected",
          verified: false,
          platform: "Snapchat",
          content: "Messi feminine dance",
          risk: "Medium",
          timestamp: "Mar 16, 9:10 AM",
          icon: "bi bi-camera",
          matchPercent: 85,
          reach: "120K views",
          detectedAt: "Mar 16, 9:10 AM",
          videoSrc: "/assets/videos/protection/Unauthorized-Messi feminine dance.mp4",
          sourceUrl: "https://www.snapchat.com/discover/story/919288228",
        },
        {
          id: "authorized-5",
          status: "authorized",
          statusLabel: "Authorized",
          verified: true,
          platform: "Lay's",
          content: "Lay's brand spot",
          risk: "Verified",
          timestamp: "Mar 15, 6:05 PM",
          icon: "bi bi-shield-check",
          matchPercent: 100,
          reach: "920K views",
          detectedAt: "Mar 15, 6:05 PM",
          videoSrc: "/assets/videos/protection/Authorized-Lays.mp4",
          sourceUrl: "https://www.lays.com/messi",
        },
        {
          id: "detected-9",
          status: "detected",
          statusLabel: "Detected",
          verified: false,
          platform: "Twitch",
          content: "Messi playing League of Legends",
          risk: "High",
          timestamp: "Mar 15, 2:41 PM",
          icon: "bi bi-broadcast",
          matchPercent: 91,
          reach: "260K views",
          detectedAt: "Mar 15, 2:41 PM",
          videoSrc: "/assets/videos/protection/Unauthorized-Messi playing league of legends-Unauthorized livestream snippet.mp4",
          sourceUrl: "https://www.twitch.tv/videos/2109428312",
        },
        {
          id: "detected-10",
          status: "detected",
          statusLabel: "Detected",
          verified: false,
          platform: "Unknown AI Marketplace",
          content: "Messi voice clone message",
          risk: "High",
          timestamp: "Mar 14, 11:55 AM",
          icon: "bi bi-exclamation-triangle",
          matchPercent: 93,
          reach: "75K views",
          detectedAt: "Mar 14, 11:55 AM",
          videoSrc: "/assets/videos/protection/Unauthorized-Messi voice clone leaving a message to a friend about a soccer game.mp4",
          sourceUrl: "https://www.unknownaimarket.com/listing/voice-clone-88",
        },
        {
          id: "authorized-6",
          status: "authorized",
          statusLabel: "Authorized",
          verified: true,
          platform: "Bad Boys",
          content: "Bad Boys promo tie-in",
          risk: "Verified",
          timestamp: "Mar 14, 9:08 AM",
          icon: "bi bi-shield-check",
          matchPercent: 100,
          reach: "610K views",
          detectedAt: "Mar 14, 9:08 AM",
          videoSrc: "/assets/videos/protection/Authorized-Bad Boys.mp4",
          sourceUrl: "https://www.sonypictures.com/movies/badboys",
        },
        {
          id: "detected-11",
          status: "detected",
          statusLabel: "Detected",
          verified: false,
          platform: "Pinterest",
          content: "AI lookbook pin",
          risk: "Low",
          timestamp: "Mar 13, 4:22 PM",
          icon: "bi bi-pin-angle",
          matchPercent: 80,
          reach: "18K views",
          detectedAt: "Mar 13, 4:22 PM",
          videoSrc: "/assets/videos/protection/Unauthorized-AI Lookbook Pin.mp4",
          sourceUrl: "https://www.pinterest.com/pin/9811740288124/",
        },
        {
          id: "authorized-7",
          status: "authorized",
          statusLabel: "Authorized",
          verified: true,
          platform: "Mastercard",
          content: "Mastercard campaign",
          risk: "Verified",
          timestamp: "Mar 13, 9:18 AM",
          icon: "bi bi-shield-check",
          matchPercent: 100,
          reach: "430K views",
          detectedAt: "Mar 13, 9:18 AM",
          videoSrc: "/assets/videos/protection/Authorized-Mastercard.mp4",
          sourceUrl: "https://www.mastercard.com/messi-campaign",
        },
        {
          id: "detected-12",
          status: "detected",
          statusLabel: "Detected",
          verified: false,
          platform: "Discord",
          content: "Messi as gladiator rumor clip",
          risk: "Medium",
          timestamp: "Mar 12, 7:50 PM",
          icon: "bi bi-chat-left-dots",
          matchPercent: 84,
          reach: "32K views",
          detectedAt: "Mar 12, 7:50 PM",
          videoSrc: "/assets/videos/protection/Unauthorized-Messi as gladiator-AI avatar rumor clip.mp4",
          sourceUrl: "https://discord.com/channels/109982312312/118723211003",
        },
        {
          id: "authorized-8",
          status: "authorized",
          statusLabel: "Authorized",
          verified: true,
          platform: "Apple MLS",
          content: "Apple MLS spot",
          risk: "Verified",
          timestamp: "Mar 12, 10:16 AM",
          icon: "bi bi-shield-check",
          matchPercent: 100,
          reach: "1.3M views",
          detectedAt: "Mar 12, 10:16 AM",
          videoSrc: "/assets/videos/protection/Authorized-Apple-MLS.mp4",
          sourceUrl: "https://tv.apple.com/show/major-league-soccer/umc.cmc.mls",
        },
      ],
    },
  },
  assets: {
    heroVideo: "/assets/videos/keal-girl-yellow-shirt.mp4",
  },
};

export default defaultBranding;
